import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import Default from '@/components/layout/Default.vue';
import { SIGN_ROUTER } from '@/modules/sign/router/signRouter';
import { PRODUCT_ROUTER } from '@/modules/master/products/router/productsRouter';
import { COMPANY_ROUTER } from '@/modules/admin/company/router/companyRouter';
import { BP_ROUTER } from '@/modules/master/bp/router/bpRouter';
import { WAREHOUSE_ROUTER } from '@/modules/master/warehouse/router/warehouseRouter';
import { COMMON_CODE_ROUTER } from '@/modules/admin/commonCode/router/commonCodeRouter';
import { CATEGORY_ROUTER } from '@/modules/admin/category/router/categoryRouter';
import { AUTHORITY_ROUTER } from '@/modules/admin/authority/router/authorityRouter';
import { USER_LIST_ROUTER } from '@/modules/admin/userList/router/userListRouter';
import { BRAND_ROUTER } from '@/modules/admin/brand/router/brandRouter';
import { BOM_ROUTER } from '@/modules/master/bom/router/bomRouter';
import { ORDER_ROUTER } from '@/modules/order/orderMaster/router/OrderRouter';
import { INBOUND_ROUTER } from '@/modules/movement/inbound/router/inboundRouter';
import { SALES_ORDER_ROUTER } from '@/modules/sales/salesOrder/router/salesOrderRouter';
import { OUTBOUND_ROUTER } from '@/modules/movement/outbound/router/outboundRouter';
import { MOVEMENT_ROUTER } from '@/modules/movement/movement/router/movementRouter';
import { TRANSACTION_ROUTER } from '@/modules/inventory/transaction/router/transactionRouter';
import { INVENTORY_DETAIL_ROUTER } from '@/modules/inventory/detail/router/inventoryDetailRouter';
import { INVENTORY_WAREHOUSE_ROUTER } from '@/modules/inventory/warehouse/router/inventoryWarehouseRouter';
import { REFRESH_TOKEN_KEY } from '@/modules/sign/constants';
import Cookies from 'js-cookie';
import { TUNING_ROUTER } from '@/modules/movement/tuning/router/tuningRouter';
import { INVENTORY_MONTH_ROUTER } from '@/modules/inventory/month/router/monthRouter';
import { INVENTORY_SITUATION_ROUTER } from '@/modules/sales/byItem/router/byItemRouter';
import { ITEMS_INQUIRY_ROUTER } from '@/modules/sales/itemsInquiry/router/itemsInquiryRouter';
import { CHANNEL_INQUIRY_ROUTER } from '@/modules/sales/channelInquiry/router/channelInquiryRouter';
import { MONTHLY_SALES_ROUTER } from '@/modules/sales/monthly/router/monthlySalesRouter';
import { DAILY_SALES_ROUTER } from '@/modules/sales/daily/router/dailySalesRouter';
import { EXPECTED_ROUTER } from '@/modules/order/expected/router/expectedRouter';
import { TRADE_ROUTER } from '@/modules/adjustment/trade/router/tradeRouter';
import { SETTLEMENT_ROUTER } from '@/modules/adjustment/settlement/router/settlementRouter';
import { MONTHLY_SETTLEMENT_ROUTER } from '@/modules/adjustment/month/router/monthlySettlementRouter';
import { REPORT_ROUTER } from '@/modules/sales/report/router/reportRouter';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: Default,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        component: () => import('@/modules/main/Main.vue'),
        name: 'Main',
        meta: {
          title: '홈',
        },
      },
      COMMON_CODE_ROUTER,
      CATEGORY_ROUTER,
      AUTHORITY_ROUTER,
      COMPANY_ROUTER,
      BRAND_ROUTER,
    ],
  },
  {
    path: '/test',
    component: () => import('@/modules/sign/components/SignLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('@/modules/test/Test.vue'),
        name: 'Test',
        meta: {
          title: '테스트',
        },
      },
    ],
  },
  SIGN_ROUTER,
  ...PRODUCT_ROUTER,
  ...BP_ROUTER,
  ...WAREHOUSE_ROUTER,
  ...USER_LIST_ROUTER,
  ...BOM_ROUTER,
  ...ORDER_ROUTER,
  ...INBOUND_ROUTER,
  ...OUTBOUND_ROUTER,
  ...SALES_ORDER_ROUTER,
  ...MOVEMENT_ROUTER,
  ...TRANSACTION_ROUTER,
  ...INVENTORY_DETAIL_ROUTER,
  ...INVENTORY_WAREHOUSE_ROUTER,
  ...TUNING_ROUTER,
  ...INVENTORY_MONTH_ROUTER,
  ...INVENTORY_SITUATION_ROUTER,
  ...ITEMS_INQUIRY_ROUTER,
  ...CHANNEL_INQUIRY_ROUTER,
  ...MONTHLY_SALES_ROUTER,
  ...DAILY_SALES_ROUTER,
  ...EXPECTED_ROUTER,
  ...TRADE_ROUTER,
  ...SETTLEMENT_ROUTER,
  ...MONTHLY_SETTLEMENT_ROUTER,
  ...REPORT_ROUTER,
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/modules/sign/components/SignLayout.vue'),
    meta: { requiresAuth: false },
    children: [
      {
        path: '',
        component: () => import('@/components/common/404Error.vue'),
        name: '404',
        meta: {
          title: '404',
        },
      },
    ],
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const isLogin = Cookies.get(REFRESH_TOKEN_KEY);
  if (to.meta.requiresAuth && !isLogin) {
    return next('/sign');
  }

  // await useAppStore().getMenuList();
  // const { userMenuList } = useAppStore();
  // if (
  //   to.path !== '/' &&
  //   !userMenuList
  //     .map((item) => item.menuList?.map((menu) => menu.path))
  //     .flat()
  //     .includes(to.path)
  // ) {
  //   return next('/');
  // }

  if (!to.meta.requiresAuth && isLogin && to.name !== '404') {
    return next('/');
  }

  next();
});

export default router;
